<template>
  <div>华夏支付回调</div>
</template>

<script>
export default {
  mounted() {
      console.log(this.$route.query)
    window.location.replace(this.$route.query.reverseUrl)
  }
}
</script>

<style></style>
